// Module
var code = "<h1 id=steps-步骤条>Steps 步骤条</h1> <p>引导用户按照流程完成任务的分步导航条，可根据实际应用场景设定步骤，步骤不得少于 2 步。</p> <h2 id=何时使用>何时使用</h2> <ul> <li>...。</li> </ul> ";
// Exports
module.exports = code;